// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__aa259","row":"ProcedureTreatmentSummary_row__1Fw6w"};